import Axios from "./axios";

const resource = "how-it-works";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}